export default __webpack_public_path__ + "src/assets/tx-status.72b010dcc4606df909ac696a9dbeaa62.svg";